import { jsx as _jsx } from "react/jsx-runtime";
import { connect } from 'react-redux';
import VenueInfo from './venueInfo';
import { getVenue } from '~/selectors/event';
const VenueInfoContainer = ({ venue, twoColumn = false }) => {
    return _jsx(VenueInfo, { venue: venue, twoColumn: twoColumn });
};
const mapStateToProps = (state) => ({
    venue: getVenue(state),
});
export default connect(mapStateToProps)(VenueInfoContainer);
